import { gql } from '@apollo/client';

const RMA_DEVICES_FRAGMENT = gql`
  fragment RmaDeviceFields on Device {
    id
    deviceId
    model
    firstStudyDate
    additionalStatus
    isRenewal
    lastSync {
      fwVersion
      schema
    }
    facility {
      id
      name
      status
    }
    canRunBiotresMCT
    lastUsed {
      study {
        id
        friendlyId
      }
    }
  }
`;

export default RMA_DEVICES_FRAGMENT;
